import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { mstrshowdataentity, Mstr_Show,showimageentity } from "@feature/types/show.type"
import { ENV } from "@app/constants/env"
import { ShowEmailNotify } from '@feature/types/showemailnotify';
import { EmailNotifyUserExhibitorDDL } from "@feature/types/showcustomer";
import { ShowRefEntity } from '@feature/types/showref.type';

import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getToken } from '@app/helpers/authProvider';
import { ShowServicesEntity } from '../../EfairsJob/types/common.lookup.types';
const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.SHOW_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  // normalize string arg to object so we can set headers
  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken(); // ensure this returns a non-empty string
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`); // use standard casing
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    // optional: retry once if unauthorized (adjust getToken refresh logic if available)
    if (result.error && result.error.status === 401 && token) {
      // If you have a refresh flow, invoke it here then retry.
      // const refreshed = await getRefreshedToken();
      // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

 const userId = localStorage.getItem("userid")
    ? parseInt(localStorage.getItem("userid")!)
    : 0;
export interface ApiResponse<T> {
  success: boolean
  message?: string
  data?: T
  error?: string
}
export const showsliceApi = createApi({
  reducerPath: 'showsliceApi',
  baseQuery: authBaseQuery,
  tagTypes: ['showmanagement'],
  endpoints: (builder) => ({

    createShow: builder.mutation<ApiResponse<mstrshowdataentity>, { show: mstrshowdataentity; selecteduserids: string }>({
      query: ({ show, selecteduserids }) => ({
        url: `Shows/CreateShow/${selecteduserids || '0'}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: show,
      }),
      invalidatesTags: ['showmanagement'],
    }),

    getShowById: builder.query<ApiResponse<mstrshowdataentity>, number>({
      query: (showId) => ({
        url: `Shows/GetShowById/${showId}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),
    emailnotificationuserdata: builder.query<ApiResponse<ShowEmailNotify>, number>({
      query: (showId) => ({
        url: `Shows/GetShowEmailNotifyUserData/${showId}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),

    enuserexhibitordll: builder.query<ApiResponse<EmailNotifyUserExhibitorDDL>, { showid: number; custid: number }>({
      query: ({ showid, custid }) => ({
        url: `Shows/GetUserExibitorddl/${showid}/${custid}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),

    createEmailNotificationShow: builder.mutation<ApiResponse<ShowEmailNotify>, { emailnotifyshow: ShowEmailNotify; UserID: number }>({
      query: ({ emailnotifyshow, UserID }) => ({
        url: `Shows/Emailnotificationcreation/${UserID}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: emailnotifyshow,
      }),
      invalidatesTags: ['showmanagement'],
    }),

    getAllShows: builder.query<ApiResponse<Mstr_Show[]>, { username: number; showId: number }>({
      query: ({ username, showId }) => ({
        url: `Shows/GetAllShowForDashboardList/${username}/${showId}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),
    // UpdateShow: builder.mutation<ApiResponse<mstrshowdataentity>, { show: mstrshowdataentity; selecteduserids: string }>({
    //   query: ({ show, selecteduserids }) => ({
    //     url: `Shows/UpdateShow/${selecteduserids || '0'}`,
    //     method: 'PUT',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: show,
    //   }),
    //   invalidatesTags: ['showmanagement'],
    // }),
    updateShow: builder.mutation<ApiResponse<mstrshowdataentity>, { show: mstrshowdataentity; selecteduserids: string }>({
      query: ({ show, selecteduserids }) => ({
        url: `Shows/UpdateShow/${selecteduserids || '0'}`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: show,
      }),
      invalidatesTags: ['showmanagement'],
    }),


    // UpdateShow: builder.mutation<
    //   ApiResponse<mstrshowdataentity>,
    //   { _showDataUpdateDto: { show: mstrshowdataentity; selecteduserids: string | number[] } }>({
    //   query: (body) => ({
    //     url: `Shows/UpdateShow/0`,
    //     method: 'PUT',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body,
    //   }), 
    //   invalidatesTags: ['showmanagement'],
    // }),
    updateShowRef: builder.mutation<ApiResponse<ShowRefEntity[]>, ShowRefEntity[]>({
      query: (showRefEntities) => ({
        url: `Shows/UpdateShowRef`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: showRefEntities,
      }),
      invalidatesTags: ['showmanagement'],
    }),

    getworefdata: builder.query<ApiResponse<ShowRefEntity>, number>({
      query: (showId) => ({
        url: `Shows/GetShowWoref/${showId}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),


    deleteEmailnotify: builder.mutation<ApiResponse<null>, { selectednids: string; }>(
      {
        query: ({ selectednids }) => ({
          url: `Shows/DeleteEmailnotify`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: { selectednids },
        }),
        invalidatesTags: ['showmanagement'],
      }
    ),

    updateShowServiceType: builder.mutation<ApiResponse<null>, ShowServicesEntity>({
      query: (updateshowservice) => ({
        url: `Shows/UpdateShowServiceType`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: updateshowservice,
      }),
      invalidatesTags: ['showmanagement'],
    }),

    updateDriverPhotoSettings: builder.mutation<ApiResponse<null>, { driverphotoflag: boolean; showid: number }>({
      query: ({ driverphotoflag, showid }) => ({
        url: `Shows/DriverPhotoSettings`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: { driverphotoflag, showid },
      }),
      invalidatesTags: ['showmanagement'],
    }),

    checkWorkOrderCount: builder.query<ApiResponse<number>, number>({
      query: (showid) => ({
        url: `Shows/CheckWorkOrderCount/${showid}`,
        method: 'GET',
      }),
      providesTags: ['showmanagement'],
    }),

    // updateShowImage: builder.mutation<ApiResponse<null>, { Showcode: string; showimagepath: string }>(
    //   {
    //   query: ({ Showcode, showimagepath }) => ({
    //     url: `Shows/UpdateShowImage/${Showcode}/${showimagepath}`,
    //     method: 'POST',
    //   }),
    //   invalidatesTags: ['showmanagement'],
    //   }
    // ),
    updateShowImage: builder.mutation<ApiResponse<null>, showimageentity>({
      query: (showimagedata) => ({
        url: `Shows/UpdateShowImage`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: showimagedata,
      }),
      invalidatesTags: ['showmanagement'],
    }),


    removeShowImage: builder.mutation<ApiResponse<null>, { Showcode: string }>(
      {
      query: ({ Showcode }) => ({
        url: `Shows/RemoveShowImage/${Showcode}`,
        method: 'POST',
      }),
      invalidatesTags: ['showmanagement'],
      }
    ),


  }),
});





export const {

  useCreateShowMutation,
  useGetShowByIdQuery,
  useEmailnotificationuserdataQuery,
  useEnuserexhibitordllQuery,
  useCreateEmailNotificationShowMutation,
  useGetAllShowsQuery,
  useUpdateShowMutation,
  useUpdateShowRefMutation,
  useGetworefdataQuery,
  useDeleteEmailnotifyMutation,
  useUpdateShowServiceTypeMutation,
  useUpdateDriverPhotoSettingsMutation,
  useCheckWorkOrderCountQuery,
  useUpdateShowImageMutation,
  useRemoveShowImageMutation,

} = showsliceApi;
